module.exports = __webpack_public_path__ + "img/学生学习.090c1103.svg";